export const REFERRALS_CONTAINER_TEST_ID = 'referrals-container'
export const REFERRALS_HERO_SECTION_TEST_ID = 'referrals-hero-section'
export const REFERRALS_JOURNEY_TEST_ID = 'referrals-journey'
